<template>
  <div v-if="isShowPage" class="home-container">
    <div class="chat-body" ref="messageBody" id="messageBody">
      <div class="chat-list">
        <div
          v-for="(item, index) in messageBubble"
          :key="index"
          class="chat-item"
          :class="[item.role]"
          :style="
            item.type == 101
              ? 'display:flex;justify-content: center;align-items:center'
              : ''
          "
        >
          <!-- <img
            src="@/assets/images/kefu.png"
            alt="机器人头像"
            v-if="item.role == 'root'"
          /> -->
          <div
            class="chat-bubble"
            :style="
              item.type == 4
                ? 'width:75%'
                : item.type == 101
                ? 'width:100%;background:none;padding:0;'
                : item.type == 10
                ? 'background:#ddd;'
                : ''
            "
          >
            <!-- 开头语 -->
            <template v-if="item.type == 100">
              <div class="start-box">
                <div class="start-title">你好，我是华图小禾</div>
                <div style="margin-bottom: 20px">
                  作为你的智能考公小助手，我既能查询考情、解答考公知识，又能推荐考公职位、推荐考公辅导课程。想知道我还能做什么？快点击下方对话框，和我对话吧！
                </div>
                <div style="margin-bottom: 20px">你可以试着问我：</div>
                <div class="start-list">
                  <div
                    class="start-item"
                    v-for="(item, index) in startList"
                    :key="index"
                    @click="send(item.content)"
                  >
                    <div>
                      <img
                        class="start-img"
                        :src="
                          require('@/assets/images/start' +
                            Number(Number(index) + 1) +
                            '.png')
                        "
                      />
                    </div>
                    <div>
                      <div class="start-item-title">{{ item.title }}</div>
                      <div class="start-item-content">
                        {{ item.content }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="item.type == 101">
              <div class="start-box1">------ 以上是历史对话 ------</div>
            </template>
            <!-- 问卷 -->
            <template v-else-if="item.type === 9">
              <div class="questionnaire">
                <div class="naire-title">
                  你好，我是华图小禾，您的智能问答助手，请在下方选择基本情况选项，我能更好解答您的问题
                </div>
                <el-form ref="form" :model="item.form" label-width="154px">
                  <el-form-item label="01 您的工作年限是？">
                    <el-select
                      v-model="item.form.workyear"
                      placeholder="请下拉选择工作年限"
                    >
                      <el-option label="0" value="0"></el-option>
                      <el-option label="1年" value="1"></el-option>
                      <el-option label="2年" value="2"></el-option>
                      <el-option label="3年" value="3"></el-option>
                      <el-option label="5年及以上" value="4"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="02 您的专业是？">
                    <el-cascader
                      v-model="item.form.major"
                      placeholder="请下拉选择对应专业"
                      :options="majorList"
                      :props="{
                        value: 'major',
                        label: 'major',
                        children: 'child_list',
                      }"
                      filterable
                      clearable
                    ></el-cascader>
                  </el-form-item>
                  <el-form-item label="03 您的学历是？">
                    <el-select
                      v-model="item.form.degree"
                      placeholder="请下拉选择最高学历"
                    >
                      <el-option label="专科" value="1"></el-option>
                      <el-option label="本科" value="2"></el-option>
                      <el-option label="硕士" value="3"></el-option>
                      <el-option label="博士" value="4"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="04 您的政治面貌是？">
                    <el-radio-group v-model="item.form.policy">
                      <el-radio label="中共党员/中共预备党员"></el-radio>
                      <el-radio label="共青团员"></el-radio>
                      <el-radio label="其他"></el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="05 意向报考地区是？">
                    <el-cascader
                      v-model="item.form.loc"
                      placeholder="请下拉选择对应地区"
                      :options="options"
                      clearable
                    ></el-cascader>
                  </el-form-item>
                  <el-form-item label="06 您的年龄是？">
                    <el-radio-group v-model="item.form.age">
                      <el-radio label="35岁以下"></el-radio>
                      <el-radio label="35岁以上"></el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      type="primary"
                      @click="onSubmit(index)"
                      :disabled="item.form.isSubmit"
                      :loading="item.form.submitLoading"
                      >{{
                        item.form.isSubmit ? "已提交成功" : "确定"
                      }}</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
            </template>
            <!-- 表格 -->
            <template v-else-if="item.type === 4">
              <div>
                <div
                  v-if="index == lastTableIndex && showScreen"
                  class="type-list"
                >
                  筛选条件：
                  <el-checkbox-group v-model="checkList" @change="typeChange">
                    <el-checkbox
                      :label="item.type"
                      v-for="item in typeList"
                      :key="item.type"
                      >{{ item.name }}</el-checkbox
                    >
                  </el-checkbox-group>
                </div>
                <el-tabs
                  v-model="activeName"
                  type="card"
                  @tab-click="tabClick"
                  v-loading="tableLoading && index == lastTableIndex"
                  element-loading-spinner="el-icon-loading"
                  :element-loading-text="loadingText"
                  element-loading-custom-class="table-loading"
                >
                  <el-tab-pane
                    v-if="item.message[0].length > 0"
                    label="国考"
                    name="country"
                  >
                    <lsf-table
                      tableType="gk"
                      :list="item.message[0]"
                    ></lsf-table>
                  </el-tab-pane>
                  <el-tab-pane
                    v-if="item.message[1].length > 0"
                    label="省考"
                    name="province"
                  >
                    <lsf-table
                      tableType="sk"
                      :list="item.message[1]"
                    ></lsf-table>
                  </el-tab-pane>
                </el-tabs>
                <div
                  v-if="
                    item.message[0].length === 0 && item.message[1].length === 0
                  "
                  class="no-data"
                >
                  暂无数据
                </div>
                <div
                  v-if="
                    index == lastTableIndex &&
                    count[activeName] > 20 &&
                    showScreen
                  "
                  class="page-box"
                >
                  <el-pagination
                    :page-size="20"
                    :pager-count="5"
                    layout="prev, pager, next"
                    :total="count[activeName]"
                    :current-page="currentPage"
                    @current-change="pageChange"
                  >
                  </el-pagination>
                </div>
              </div>
            </template>
            <!-- 文本带“猜您想问” -->
            <template v-else-if="item.type === 5">
              <div class="other-box">
                <div v-html="item.message"></div>
                <div class="other-quesiton">
                  <span class="other-title">猜您想问：</span>
                  <div class="other-content" @click="send(item.question)">
                    {{ item.question }}
                  </div>
                </div>
              </div>
            </template>
            <!-- 加载提示 -->
            <template v-else-if="item.type === 3">
              <div class="loading">
                <span>
                  <!-- 请给我一些时间，我正在思考答案 -->
                  {{ item.message }}
                  <b></b>
                  <b></b>
                  <b></b>
                </span>
              </div>
            </template>
            <!-- 停止响应的空文本 -->
            <template v-else-if="item.type === 7">
              <div></div>
            </template>
            <!-- 视频内容 -->
            <template v-else-if="item.type === 8">
              <a
                href="javascript:void(0)"
                @click="playVideo(item.message, item.time)"
                >{{ item.message }}</a
              >
            </template>
            <!-- 置灰对话框 -->
            <template v-else-if="item.type === 10">
              <div class="">{{ item.message }}</div>
            </template>
            <!-- 纯文本 -->
            <template v-else-if="typeof item.message === 'string'">
              <div v-html="changeHref(item.message)"></div>
            </template>
            <div v-if="isShowRate(item, index)" class="rate-box">
              <img
                v-if="item.active && item.active == 1"
                class="zan"
                @click="toEval(item, 0)"
                src="@/assets/like/赞2.png"
                alt=""
              />
              <img
                v-if="!item.active"
                class="zan"
                @click="toEval(item, 1)"
                src="@/assets/like/赞1.png"
                alt=""
              />
              <img
                v-if="item.active && item.active == -1"
                @click="toEval(item, 0)"
                class="cai"
                src="@/assets/like/踩2.png"
                alt=""
              />
              <img
                v-if="!item.active"
                class="cai"
                @click="toEval(item, -1)"
                src="@/assets/like/踩1.png"
                alt=""
              />
              <div v-if="item.showFeedback" class="feedback-box">
                <i class="el-icon-close" @click="hideFeedback(item)"></i>
                <div class="feedback-title">您的反馈将帮助小禾优化进步</div>
                <div class="feedback-list">
                  <!-- <div
                    class="feedback-item"
                    v-for="(tag, index) in tagList"
                    :key="index"
                    @click="chooseTag(item,tag)"
                  >
                    {{ tag }}
                  </div> -->
                  <el-checkbox-group v-model="item.feedbackTagList">
                    <el-checkbox-button
                      v-for="tag in tagList"
                      :label="tag"
                      :key="tag"
                      >{{ tag }}</el-checkbox-button
                    >
                  </el-checkbox-group>
                </div>
                <div class="feedback-input">
                  <el-input
                    v-model="item.feedbackComment"
                    placeholder="其他更多反馈"
                    prefix-icon="el-icon-edit"
                  ></el-input>
                </div>
                <div class="feedback-btn">
                  <el-button type="danger" @click="submitFeedback(item)"
                    >提交</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- <img
            src="@/assets/images/user.png"
            alt="用户头像"
            v-if="item.role == 'user'"
          /> -->
        </div>
      </div>
    </div>
    <div
      v-if="!isInAnser && candidate && candidate.length > 0"
      class="chat-ass"
    >
      <div>您可以继续问</div>
      <!-- <div class="ass-list"> -->
      <div
        class="ass-item"
        v-for="(item, index) in candidate"
        :key="index"
        @click="$refs.edit.innerHTML = item"
      >
        {{ item }}
      </div>
      <!-- </div> -->
      <div class="change-ass" @click="changeAss">换一换</div>
    </div>
    <div class="chat-message">
      <div class="send-content">
        <div
          contenteditable="true"
          class="edit-box"
          ref="edit"
          @keydown="textareaKeydown($event)"
        ></div>
        <div class="stop-request" v-if="isInAnser" @click="stopRequest">
          <div class="stop-icon"></div>
          <div class="stop-text">停止</div>
        </div>
        <svg
          v-else
          class="send-svg"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          @click="send()"
        >
          <path
            fill="#0ac66c"
            d="M12.8147 12.1969L5.28344 13.4521C5.10705 13.4815 4.95979 13.6029 4.89723 13.7704L2.29933 20.7278C2.05066 21.3673 2.72008 21.9773 3.33375 21.6705L21.3337 12.6705C21.8865 12.3941 21.8865 11.6052 21.3337 11.3288L3.33375 2.32885C2.72008 2.02201 2.05066 2.63206 2.29933 3.2715L4.89723 10.2289C4.95979 10.3964 5.10705 10.5178 5.28344 10.5472L12.8147 11.8024C12.9236 11.8205 12.9972 11.9236 12.9791 12.0325C12.965 12.1168 12.899 12.1829 12.8147 12.1969Z"
          ></path>
        </svg>
        <!-- <div class="send" @click="send()">
          <div v-if="isInAnser" class="loading">
            <span>
              <b></b>
              <b></b>
              <b></b>
            </span>
          </div>
          <span v-else>发送</span>
        </div> -->
      </div>
      <div class="select-box">
        <el-popover
          placement="top"
          width="60"
          trigger="click"
          transition="el-zoom-in-left"
        >
          <div class="select-list">
            <ul>
              <li>
                <a
                  href="https://www.huatu.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  >华图官网</a
                >
              </li>
              <li>
                <a
                  href="https://v.huatu.com/tiku/"
                  target="_blank"
                  rel="noopener noreferrer"
                  >最新题库</a
                >
              </li>
              <li>
                <a href="tel:4006019999" rel="noopener noreferrer">电话咨询</a>
              </li>
              <li>
                <a
                  href="https://www.huatu.com/list/4554_1.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  >报考公告</a
                >
              </li>
            </ul>
          </div>
          <i slot="reference" class="el-icon-circle-plus-outline"></i>
        </el-popover>
      </div>
    </div>
    <loading :loading="Loading" />
    <el-dialog
      title="视频播放"
      :visible.sync="showVideo"
      custom-class="video-dialog"
      :key="Date.now()"
      @close="closeVideo"
    >
      <video ref="videoPlayer" class="video-js"></video>
    </el-dialog>
  </div>
  <div v-else class="page-info">{{ pageInfo }}</div>
</template>

<script>
import {
  preferredWx,
  getImgWx,
  newPreferredWx,
  preferredLsf2,
  positionSort,
  possiblyAsk,
  hisConverDev,
  majorListDev,
  profileDev,
  faq5,
} from "@/utils/api";
import Loading from "@/components/Loading";
import { MessageBox, Message } from "element-ui";
import LsfTable from "./components/lsftable.vue";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { URL_ENV } from "@/utils/requestgpt";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import { changeHref } from "@/utils/index";
import $ from "jquery";

import videojs from "video.js";

import { options } from "./const";

let controller = "";
let signal = "";

export default {
  name: "chatRoot",
  components: {
    Loading,
    LsfTable,
  },
  data() {
    return {
      Loading: false,
      userMeasage: "",
      tempMessage: "",
      messageBubble: [
        {
          role: "root",
          type: 101,
          message: "欢迎来到ai客服",
        },
        {
          role: "root",
          type: 100,
          message: "",
        },
        // {
        //   role: "root",
        //   type: 9,
        //   message:
        //     "你好，我是华图小禾，您的智能问答助手，请在下方选择基本情况选项，我能更好解答您的问题",
        // },
      ],
      tips: ["小禾消息正在传输", "小禾的消息马上就到"],
      isInAnser: false,
      idTimer: null,
      conversation_id: Math.random().toString(16).slice(2),
      round: 0,
      visitorId: "",
      uid: "",
      typeList: [
        {
          name: "不限学位",
          type: "degree",
        },
        {
          name: "不限专业",
          type: "major",
        },
        {
          name: "不限政治面貌",
          type: "political_status",
        },
        {
          name: "不限工作经历",
          type: "work_year",
        },
      ],
      checkList: [],
      activeName: "country",
      currentPage: 1,
      count: {
        country: 0,
        province: 0,
      },
      tableLoading: false,
      loadingText: "",
      showScreen: true, //最后一项表格是否显示筛选等操作
      isForm: false,
      changeHref,
      isShowPage: false,
      pageInfo: "",
      startList: [
        {
          title: "考情查询",
          icon: "",
          content: "2024年国家公务员考试报名时间",
        },
        {
          title: "考公知识",
          icon: "",
          content: "应届毕业生考上公务员之后可以不报道吗",
        },
        {
          title: "考公职位推荐",
          icon: "",
          content: "请推荐2024年国考会计专业应届毕业生岗位",
        },
        {
          title: "课程推荐",
          icon: "",
          content: "请推荐2024年国考行政能力测试课程",
        },
      ],
      candidate: [],
      videoUrl: "",
      showVideo: false,
      player: null,
      videoOptions: {},

      pageStart: 0,
      pageSize: 10,
      hisNoMore: false,

      options,
      majorList: [],

      form: {
        workyear: "",
        major: [],
        age: "",
        policy: "",
        loc: [],
        degree: "",
      },
      isSubmit: false,
      submitLoading: false,
      lastTableIndex: 0,

      tagList: [
        "答非所问",
        "与上下文无关",
        "逻辑不合理",
        "无关内容太多",
        "重复提问",
        "与事实不符",
        "回答笼统不具体",
      ],
    };
  },
  methods: {
    //监听按键操作
    textareaKeydown(event) {
      if (event.keyCode === 13) {
        //enter
        this.send();
        event.preventDefault(); // 阻止浏览器默认换行操作
        this.$refs.edit.blur();
        return false;
      }
    },
    chageConversationId() {
      this.showScreen = true;
      clearInterval(this.idTimer);
      // this.idTimer = setInterval(() => {
      //   this.conversation_id = Math.random().toString(16).slice(2);
      //   this.round = 0;
      //   this.showScreen = false;
      // }, 300000);
    },
    async send(paramsKey, noUser) {
      if (this.isInAnser) return;
      // 若是没有信息则不发送
      if (paramsKey) {
        this.userMeasage = paramsKey;
      } else {
        this.userMeasage = this.$refs.edit.innerHTML;
      }
      this.$refs.edit.innerHTML = "";
      if (!this.userMeasage || this.userMeasage.charCodeAt(0) === 10) {
        return;
      }
      this.checkList = [];

      this.isInAnser = true;
      if (!noUser) {
        this.storeDataUpdate("user", this.userMeasage);
      }
      this.tempMessage = this.userMeasage;
      this.userMeasage = "";

      // 走问答接口
      // 展示加载问题
      this.storeDataUpdate("root", this.getTips(), 3);

      this.chageConversationId();

      let that = this;

      controller = new AbortController();
      signal = controller.signal;
      this.isForm = false;

      faq5({
        uid: that.uid,
        sid: that.visitorId,
        question: that.tempMessage,
        // conversation_id: that.conversation_id.toString(),
        round: that.round.toString(),
      })
        .then((res) => {
          that.round += 1;
          console.log("faq5", res.data.data);
          let data = res.data;
          if (data.data.type == "JOB") {
            // that.count = {
            //   country: data.data.count[0],
            //   province: data.data.count[1],
            // };
            that.checkList = [...data.data.unlimited_opts];
            that.handleReq();
            that.lastTableIndex = that.messageBubble.length - 1;
            // that.changeBubble(
            //   that.messageBubble[that.messageBubble.length - 1],
            //   data.data.jobList,
            //   4,
            //   0,
            //   that.round.toString()
            // );
          } else if (data.data.type == "PG") {
            that.changeBubble(
              that.messageBubble[that.messageBubble.length - 1],
              data.data.answer.replace(/(\n)|(\\n)/g, "</br>"),
              6,
              0,
              that.round.toString()
            );
          } else if (data.data.type == "VIDEO") {
            that.changeBubble(
              that.messageBubble[that.messageBubble.length - 1],
              data.data.answer,
              8,
              0,
              that.round.toString(),
              "",
              data.data.startTime
            );
          } else if (data.data.type == "QUE") {
            let form = {
              workyear: "",
              major: [],
              age: "",
              policy: "",
              loc: [],
              degree: "",
              isSubmit: false,
              submitLoading: false,
            };
            that.changeBubble(
              that.messageBubble[that.messageBubble.length - 1],
              data.data.answer,
              9,
              0,
              that.round.toString(),
              "",
              "",
              form
            );
          } else if (data.data.type.toUpperCase() == "TEST") {
            that.changeBubble(
              that.messageBubble[that.messageBubble.length - 1],
              data.data.answer.replace(/(\n)|(\\n)/g, "</br>"),
              10,
              0,
              that.round.toString()
            );
          } else {
            if (data.data.other_ques) {
              if (that.messageBubble[that.messageBubble.length - 1].type == 3) {
                that.changeBubble(
                  that.messageBubble[that.messageBubble.length - 1],
                  data.data.answer.replace(/(\n)|(\\n)/g, "</br>"),
                  5,
                  0,
                  that.round.toString(),
                  data.data.other_ques
                );
              } else {
                that.$set(
                  that.messageBubble[that.messageBubble.length - 1],
                  "message",
                  (that.messageBubble[that.messageBubble.length - 1].message +=
                    data.data.answer.replace(/(\n)|(\\n)/g, "</br>"))
                );
                setTimeout(() => {
                  that.messageBody.scrollTop = that.messageBody.scrollHeight;
                });
              }
            } else {
              if (
                that.messageBubble[that.messageBubble.length - 1].type !== 0
              ) {
                that.changeBubble(
                  that.messageBubble[that.messageBubble.length - 1],
                  data.data.answer.replace(/(\n)|(\\n)/g, "</br>"),
                  0,
                  0,
                  that.round.toString()
                );
              } else {
                that.$set(
                  that.messageBubble[that.messageBubble.length - 1],
                  "message",
                  (that.messageBubble[that.messageBubble.length - 1].message +=
                    data.data.answer.replace(/(\n)|(\\n)/g, "</br>"))
                );
                setTimeout(() => {
                  that.messageBody.scrollTop = that.messageBody.scrollHeight;
                });
              }
            }
          }

          that.isInAnser = false;
          console.log("that.$refs.edit", that.$refs.edit);
          that.$refs.edit.focus();
          // controller.abort();
          possiblyAsk({
            uid: that.uid,
            sid: that.visitorId,
            question: that.tempMessage,
            round: that.round.toString(),
            switch: "0",
          }).then((res) => {
            that.candidate = res.data.candidate;
            setTimeout(() => {
              that.messageBody.scrollTop = that.messageBody.scrollHeight;
            });
          });
        })
        .catch((err) => {
          that.isInAnser = false;
          that.$refs.edit.focus();
        });
    },
    changeAss() {
      let that = this;
      possiblyAsk({
        uid: that.uid,
        sid: that.visitorId,
        question: that.tempMessage,
        round: that.round.toString(),
        switch: "1",
      }).then((res) => {
        that.candidate = res.data.candidate;
      });
    },
    stopRequest() {
      if (this.isForm) {
        this.tableLoading = false;
        signal.cancel("Operation canceled by the user.");
        this.isInAnser = false;
      } else {
        controller.abort();
        this.isInAnser = false;
        this.messageBubble.pop();
      }
    },

    storeDataUpdate(role, mesg, type) {
      let root = {
        role: role,
        message: mesg,
        type,
      };
      this.messageBubble.push(root);
      // 结束
      // this.Loading = false
      setTimeout(() => {
        this.messageBody.scrollTop = this.messageBody.scrollHeight;
      });
    },
    /**
     *
     * @param {*} type 0:字符串 3:加载提示 4:表格 5:猜你想问 6:流式请求返回的加载提示信息 7:停止响应之后的空对话 8:视频内容 9、问卷 10、置灰对话框  100、101:开头语
     * @param {*} time 视频类型的回答视频的开始播放时间
     * @param {*} isRate 是否赞过踩过
     */

    changeBubble(item, message, type = 0, isRate, round, question, time, form) {
      this.$set(item, "message", message);
      this.$set(item, "type", type);
      this.$set(item, "active", isRate);
      this.$set(item, "round", round);
      this.$set(item, "question", question);
      this.$set(item, "time", time);
      this.$set(item, "form", form);
      // 保存气泡的长度
      this.$set(item, "length", (message && message.length) || 0);

      this.$set(item, "showFeedback", false);
      this.$set(item, "feedbackTagList", []);
      this.$set(item, "feedbackComment", "");

      setTimeout(() => {
        this.messageBody.scrollTop = this.messageBody.scrollHeight;
      });
    },
    getTips() {
      let tip = this.tips[Math.floor(Math.random() * this.tips.length)];
      return tip;
    },
    typeChange() {
      this.currentPage = 1;
      this.count = {
        country: 0,
        province: 0,
      };
      this.handleReq();
    },
    handleReq() {
      this.tableLoading = true;
      this.isInAnser = true;
      this.chageConversationId();
      controller = this.axios.CancelToken;
      signal = controller.source();
      this.isForm = true;
      this.axios
        .post(
          URL_ENV.chatDevServerHost + "/PositionSort",
          {
            uid: this.uid,
            sid: this.visitorId,
            conversation_id: this.conversation_id.toString(),
            unlimited: this.checkList,
            page: this.currentPage,
          },
          {
            timeout: 0, // 设置超时时间为 0/null 表示永不超时
            cancelToken: signal.token, // 绑定取消请求的信号量
          }
        )
        .then((res) => {
          this.isInAnser = false;
          this.tableLoading = false;
          this.count = {
            country: res.data.data.count[0],
            province: res.data.data.count[1],
          };
          this.changeBubble(
            this.messageBubble[this.lastTableIndex],
            res.data.data.jobList,
            4,
            0,
            this.round.toString()
          );
        })
        .catch((error) => {
          this.isInAnser = false;
          this.tableLoading = false;
        });
      // positionSort({
      //   user_id: this.visitorId,
      //   conversation_id: this.conversation_id.toString(),
      //   unlimited: this.checkList,
      //   page: this.currentPage,
      // })
      //   .then((res) => {
      //     this.isInAnser = false;
      //     this.tableLoading = false;
      //     this.count = {
      //       country: res.data.data.count[0],
      //       province: res.data.data.count[1],
      //     };
      //     this.changeBubble(
      //       this.messageBubble[this.messageBubble.length - 1],
      //       res.data.data.jobList,
      //       4,
      //       0,
      //       this.round.toString()
      //     );
      //   })
      //   .catch((error) => {
      //     this.isInAnser = false;
      //     this.tableLoading = false;
      //   });
    },
    pageChange(val) {
      this.currentPage = val;
      this.count = {
        country: 0,
        province: 0,
      };
      this.handleReq();
    },
    tabClick() {
      this.currentPage = 1;
    },
    isShowRate(item, index) {
      if (item.type === 100 || item.type === 101 || item.type == 9)
        return false;
      if (item.role == "user") return false;
      if (index == this.messageBubble.length - 1) {
        if (this.isInAnser) return false;
        if (item.type === 7) return false;
        return true;
      } else {
        if (
          item.type === 0 ||
          item.type == 4 ||
          item.type == 5 ||
          item.type == 8
        )
          return true;
        return false;
      }
    },
    /**
     *
     * @param {* 0：取消 1:赞 -1:踩} rate
     */
    toEval(item, rate, tag, comment) {
      if (rate == -1) {
        this.$set(item, "showFeedback", true);
        return;
      }
      this.$set(item, "active", rate);
      feedback({
        uid: this.uid,
        sid: this.visitorId,
        // conversation_id: this.conversation_id.toString(),
        round: item.round.toString(),
        emotion: rate,
        tag: [],
        comment: "",
      }).then((res) => {});
    },
    hideFeedback(item) {
      this.$set(item, "showFeedback", false);
    },
    submitFeedback(item) {
      this.$set(item, "active", -1);
      this.$set(item, "showFeedback", false);
    },
    playVideo(url, time = 0) {
      this.videoOptions = {
        autoplay: true,
        controls: true,
        preload: "auto",
        sources: [
          {
            src: url,
          },
        ],
      };

      this.videoUrl = url;
      this.showVideo = true;
      setTimeout(() => {
        this.player = videojs(
          this.$refs.videoPlayer,
          this.videoOptions
          // function onPlayerReady() {
          //   console.log("onPlayerReady", this);
          // }
        );
        this.player.currentTime(time);
      });
    },
    closeVideo() {
      if (this.player) {
        // this.player.pause();
        this.player.dispose();
        this.player = null;
      }
    },

    getHisConver(start) {
      hisConverDev({
        // uid: "74ae2dce36f63661e3c62b9796503409",
        uid: this.uid,
        pageStart: this.pageStart,
        pageSize: this.pageSize,
      }).then((res) => {
        this.getMajorList();
        let arr = [];
        if (res.data.conversationList.length < this.pageSize) {
          this.hisNoMore = true;
        }
        res.data.conversationList.forEach((data) => {
          let type = 0;
          if (data.type == "JOB") {
            type = 4;
          } else if (data.type == "VIDEO") {
            type = 8;
          }
          arr.push({
            role: "user",
            message: data.question,
            type: 0,
          });
          arr.push({
            role: "root",
            message: data.answer,
            type,
            active: 0,
            round: "",
            question: "",
            time: data.start_time,
          });
        });
        this.messageBubble = arr.concat(this.messageBubble);
        if (start) {
          setTimeout(() => {
            this.messageBody.scrollTop = this.messageBody.scrollHeight;
          });
        } else {
          this.messageBody.scrollTop = 100;
        }
      });
    },
    async getPossiblyAsk() {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      this.uid = result.visitorId;

      this.getHisConver(1);

      possiblyAsk({
        uid: this.uid,
        sid: this.visitorId,
        question: this.tempMessage,
        round: this.round.toString(),
        switch: "0",
      }).then((res) => {
        res.data.candidate.forEach((item, index) => {
          this.startList[index].content = item;
        });
      });
    },
    onSubmit(index) {
      if (this.messageBubble[index].form.workyear === "") {
        return Message({
          message: "请选择工作年限",
          type: "warning",
          duration: 3 * 1000,
        });
      } else if (this.messageBubble[index].form.major.length == 0) {
        return Message({
          message: "请选择对应专业",
          type: "warning",
          duration: 3 * 1000,
        });
      } else if (!this.messageBubble[index].form.degree) {
        return Message({
          message: "请选择最高学历",
          type: "warning",
          duration: 3 * 1000,
        });
      } else if (!this.messageBubble[index].form.policy) {
        return Message({
          message: "请选择政治面貌",
          type: "warning",
          duration: 3 * 1000,
        });
      } else if (this.messageBubble[index].form.loc.length == 0) {
        return Message({
          message: "请选择对应地区",
          type: "warning",
          duration: 3 * 1000,
        });
      } else if (!this.messageBubble[index].form.age) {
        return Message({
          message: "请选择您的年龄",
          type: "warning",
          duration: 3 * 1000,
        });
      }
      this.messageBubble[index].form.submitLoading = true;
      let form = { ...this.messageBubble[index].form };
      form.major =
        this.messageBubble[index].form.major[
          this.messageBubble[index].form.major.length - 1
        ];
      let loc = [];
      loc.push(
        this.messageBubble[index].form.loc[
          this.messageBubble[index].form.loc.length - 1
        ]
      );
      form.loc = loc;
      form.uid = this.uid;
      form.sid = this.visitorId;
      profileDev(form)
        .then((res) => {
          this.messageBubble[index].form.submitLoading = false;
          this.send("问卷填写好了", true);
          if (res.data.code == 200) {
            this.messageBubble[index].form.isSubmit = true;
          }
        })
        .catch(() => {
          this.messageBubble[index].form.submitLoading = false;
        });
    },
    getMajorList() {
      majorListDev().then((res) => {
        this.majorList = res.data.data;
      });
    },
  },
  created() {
    document.title = "ai客服";
    let sid =
      this.$route.query.sid === undefined
        ? this.$route.query.uid
        : this.$route.query.sid;
    let url = `http://39.103.228.66:22100/verify-saler?sid=` + sid;
    this.visitorId = sid;
    $.ajax({
      type: "get",
      url: url,
      async: true,
      success: (data) => {
        if (data.useful) {
          this.isShowPage = true;
          this.$forceUpdate();
          this.getPossiblyAsk();
          setTimeout(() => {
            this.messageBody = this.$refs.messageBody;
            const dom = document.getElementById("messageBody");
            dom.addEventListener("scroll", () => {
              // const clientHeight = dom.clientHeight;
              const scrollTop = dom.scrollTop;
              // const scrollHeight = dom.scrollHeight;
              if (scrollTop == 0 && !this.hisNoMore) {
                if (this.messageBubble.length >= this.pageSize) {
                  this.pageStart++;
                  this.getHisConver();
                }
              }
            });
          });
        } else {
          this.pageInfo = data.info;
        }
      },
    });
  },
  destoryed() {
    const dom = document.getElementById("messageBody");
    dom.removeEventListener("scroll", () => {});
  },
  async mounted() {
    // this.timer = setInterval(() => {
    //   this.date = new Date();
    // }, 1000);
    // this.userId = Math.floor(Math.random() * 10000);
    // 关闭定时器 不自动刷新conversation_id
    // this.idTimer = setInterval(() => {
    //   this.conversation_id++;
    // }, 300000);
  },

  beforeRouteLeave(to, from, next) {
    from.meta.scrollTop = this.messageBody.scrollTop;
    from.meta.scrollEl = this.messageBody;
    next();
  },
  directives: {
    LongPress: {
      inserted(el, binding, vnode) {
        let timer = null;

        function touchStart(e) {
          clearTimeout(timer);
          timer = setTimeout(function () {
            let touches = e.touches[0];
            let context = vnode.context;
            let community = context.$refs.community;
          }, 300);
        }

        function touchMove(e) {
          clearTimeout(timer);
          e.preventDefault();
        }

        function touchEnd() {
          clearTimeout(timer);
        }

        el._touchStart = touchStart;
        el._touchMove = touchMove;
        el._touchEnd = touchEnd;
        el.addEventListener("touchstart", el._touchStart);
        el.addEventListener("touchmove", el._touchMove);
        el.addEventListener("touchend", el._touchEnd);
      },
      unbind(el, binding, vnode) {
        el.removeEventListener("touchstart", el._touchStart);
        el.removeEventListener("touchmove", el._touchMove);
        el.removeEventListener("touchend", el._touchEnd);
        delete el._touchStart;
        delete el._touchMove;
        delete el._touchEnd;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.home-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  -webkit-overflow-scrolling: touch;
  overflow: hidden;
  max-width: 900px;
  margin: 0 auto 10px auto;
}

.chat-header {
  /* 聊天机器人头部信息 */
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0 6px 12px rgba(39, 165, 251, 0.25);
  font-size: 0;
}

.chat-header img {
  width: 100%;
}

.chat-header .logo {
  flex: 0 2 auto;
  width: 142px;
}

.chat-header .logo img {
  width: 100%;
  height: 100%;
}

.chat-header .des {
  /* font-size: 15px; */
}

.chat-header .des .vertial::after {
  content: "|";
  margin-left: 2px;
}

.chat-body {
  width: 100%;
  padding-top: 30px;
  height: calc(94vh - 57px);
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  /*有回弹效果*/
  /* border-bottom: 1px solid #bbb; */
  // background: #f6f8fa;
}

.chat-message {
  position: relative;
  width: 100%;
  /*min-height: 6vh;*/
  box-sizing: border-box;
  line-height: 6vh;
  display: flex;
  align-items: center;
  // flex-direction: column;
  padding: 14px 14px 14px 22px;
  // background: #cce8fc;
  // background: #fff;
  .select-box {
    display: flex;
    align-items: center;
    margin-left: 14px;
    .el-icon-circle-plus-outline {
      font-size: 34px;
      color: #5ac275;
    }
  }
}

.chat-message .send-content {
  display: flex;
  align-items: center;
  background: #f6f8fa;
  // border: 1px solid #ccc;
  border-radius: 24px;
  padding: 0 10px;
  flex: 1;
  .send-svg {
    width: 24px;
    color: #1b4aef;
    cursor: pointer;
  }

  .stop-request {
    position: initial;
    line-height: 1;
    border: none;
    background: none;
    // padding: 0;
    transform: none;
    .stop-icon {
      // background: #0ac66c;
      background: #cc3026;
    }
  }
}

.chat-message .edit-box {
  flex: 1;
  font-size: 14px;
  outline: none;
  // background: #f6f8fa;
  padding: 11px 10px;
  box-sizing: border-box;
  max-height: 88px;
  margin-right: 10px;
  overflow: hidden;
  border-radius: 6px;
  user-modify: read-write-plaintext-only;
  -webkit-user-modify: read-write-plaintext-only;
  overflow-y: scroll;
  line-height: 22px;
  // border: 1px solid #ccc;
  box-sizing: border-box;
}

.chat-message .edit-box:empty:before {
  content: "请输入您的问题";

  color: gray;
}

.chat-message .edit-box:focus:before {
  content: none;
}

.send {
  width: 60px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  border-radius: 4px;
  background: #145dff;
  font-size: 14px;
  color: #feffff;
  font-family: PingFangSC-Regular;
  cursor: pointer;
}

.community {
  position: absolute;
  right: 2px;
  bottom: 60px;
  font-size: 12px;
  color: #fff;
  display: inline-block;
  width: 50px;
  height: 50px;
  line-height: 50px;
  border-radius: 50%;
  text-align: center;
  background: rgba(45, 140, 240, 0.7);
}

.chat-list {
  -webkit-overflow-scrolling: touch;
  padding-top: 10px;
  padding-bottom: 20px;
}

.chat-item {
  display: inline-flex;
  align-content: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0 16px 0 16px;
  margin-bottom: 30px;
  .rate-box {
    position: relative;
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    height: 20px;
    img {
      width: 20px;
      height: auto;
      cursor: pointer;
    }
    .cai {
      width: 17px;
      margin-left: 10px;
    }
    .feedback-box {
      position: absolute;
      bottom: 100%;
      right: 0;
      padding: 10px;
      border-radius: 10px;
      background: #fff;
      box-shadow: 0 6px 12px rgba(39, 165, 251, 0.25);
      .el-icon-close {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        font-size: 18px;
      }
      .feedback-title {
        margin-bottom: 10px;
        font-weight: 700;
        font-size: 18px;
      }
      .feedback-list {
        display: flex;
        max-width: 400px;
        flex-wrap: wrap;
        .feedback-item {
          padding: 4px 10px;
          background: #f4f6f7;
          border-radius: 6px;
          margin: 0 10px 10px 0;
          cursor: pointer;
        }
      }
      .feedback-input {
        margin-bottom: 10px;
      }
      .feedback-btn {
        text-align: center;
      }
    }
  }
}

.chat-item img:not(.cai):not(.zan):not(.img-message):not(.start-img) {
  width: 26px;
  height: 26px;
  vertical-align: top;
  background: #145dff;
  border-radius: 50%;
  padding: 9px;
}
.img-message {
  max-width: 500px;
  max-height: 500px;
}
.user img {
  background: #0ac66c !important;
}

.chat-bubble {
  position: relative;
  display: inline-block;
  border: none;
  border-radius: 0px;
  padding: 2px 8px;
  max-width: 75%;
  line-height: 22px;
  word-wrap: break-word;
  border-radius: 12px;
  word-break: break-all;
  letter-spacing: 0.01rem;
  font-size: 14px;
  vertical-align: middle;
}

.chat-bubble .recomand-list {
  display: flex;
}

.chat-bubble .recomand-list div {
  width: 120px;
  height: 120px;
  background: red;
  margin-right: 5px;
}

.chat-bubble .qa-tip {
  font-size: 16px;
  margin: 0;
  font-weight: 500;
  margin-bottom: 0;
}

.chat-bubble .qa-list {
  cursor: pointer;
  color: #2d8cf0;
  user-select: none;
}

.chat-bubble .qa-list :active {
  color: #145dff;
}

.chat-bubble ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.chat-bubble .qa-tip {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 0;
}

.chat-bubble .qa-list {
  cursor: pointer;
  color: #2d8cf0;
  user-select: none;
}

.chat-bubble .qa-list :active {
  color: #145dff;
}

.chat-bubble ul {
  margin: 0;
  padding: 0;
}

/* 这便是机器人 */
.root {
  align-items: flex-start;
}

.root .chat-bubble {
  background: #fff;
  color: #333;
  margin-left: 10px;
  padding: 14px;
}

.chat-bubble::before {
  /* 三角形 */
  // position: absolute;
  // content: "";
  // height: 0;
  // width: 0;
  // border: 7px solid transparent;
}

.root .chat-bubble::before {
  border-right-color: #fff;
  /* border-right-color: rgb(141, 250, 105); */
  left: -13px;
}

/* 这边是用户 */
.user {
  display: inline-flex;
  justify-content: flex-end;
  align-items: flex-start;
}

.user .chat-bubble {
  color: #fff;
  background: #e5646c;
  // background: linear-gradient(130deg, #2870ea 20%, #1b4aef 77.5%);
  margin-right: 10px;
  padding: 6px 10px;
}

.user .chat-bubble::before {
  /* border-left-color: #60ba99; */
  border-left-color: #0ac66c;
  right: -12px;
}

/*各种分类展示 样式表*/
.ppt,
.book {
  padding: 10px;
  height: 100%;
  /*display: flex;*/
  flex-direction: column;
  font-size: 12px;
}
.ppt,
.book .des {
  border-top: 1px solid #ccc;
  margin: 10px 0;
}

.ppt .ppt-cover,
.book .book-cover {
  flex: 0 0 80%;
  overflow: hidden;
}

.des {
  text-overflow: ellipsis;
  /*overflow: hidden;*/
  /*white-space: nowrap;*/
}

.news {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.news-left {
  flex: 0 0 20%;
  width: 20%;
  box-sizing: border-box;
  padding: 5px 0;
  height: 100%;
}

.news-right {
  display: flex;
  flex-direction: column;
  flex: 0 1 80%;
  width: 80%;
  align-self: flex-start;
  margin-top: 8px;
  box-sizing: border-box;
  padding: 0 10px;
  height: 100%;
}

.news-left img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-right .title {
  width: 100%;
  flex: 0 0 28%;
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 5px;
}

.news-right .abstract {
  flex: 0 0 41%;
  font-size: 12px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 16px;
}

.music {
  /* 音频样式 */
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 5px;
}

.music p {
  font-size: 12px;
  line-height: 15px;
  width: 100%;
  overflow: hidden;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}

.music div {
  width: 100%;
}

.music audio {
  height: 45px;
  width: 250px;
}

/*.mint-ui*/
.mint-button--small {
  padding: 0 3px;
}

/*关闭按钮*/
.close-btn {
  position: absolute;
  z-index: 99999;
  right: 0;
  top: 0;
  width: 30px;
  height: 30px;
  background: red;
}

.mint-button--small {
  line-height: 33px;
}

.accurateParent {
  position: relative;
  margin-bottom: 15px;
  user-select: none;
}

.omit-the-hidden {
  /* 省略展示额外内容 */
  position: relative;
  max-height: 160px;
  margin-bottom: 15px;
  overflow: hidden;
}

.omit-the-hidden .mask {
  /* 蒙层遮罩*/
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20px;
  opacity: 0.6;
  background: #fff;
  background-image: linear-gradient(
    -180deg,
    rgba(255, 255, 255, 0) 0%,
    #fff 70%
  );
}

.show-more {
  /* 展示更多按钮 */
  position: absolute;
  width: 45px;
  /* left: 0; */
  right: 0;
  margin: auto;
  width: 100%;
  text-align: center;
  color: #fff;
  height: 25px;
  line-height: 25px;
  font-size: 14px;
  border-radius: 2px;
  cursor: pointer;
  background: rgba(244, 68, 68, 0.4);
  /* background: #26a2ff; */
  border: 1px dashed rgba(165, 85, 85, 0.4);
  z-index: 3;
  bottom: -2px;
}

.show-more:active {
  background-color: rgba(211, 51, 51, 0.9);
}

/*loading 动画*/
.loading span {
  margin-top: 15px;
  font-size: 14px;
  font-weight: 200;
  font-family: Verdana, Geneva, Arial, sans-serif;
}

.loading span b {
  content: "";
  margin-right: 3px;
  display: inline-block;
  width: 3px;
  height: 3px;
  background: #000;
  border-radius: 50%;
}

.loading span b:nth-child(1) {
  animation: beating 0.8s ease infinite alternate;
}

.loading span b:nth-child(2) {
  animation: beating 0.8s ease infinite alternate 0.3s;
}

.loading span b:nth-child(3) {
  animation: beating 0.8s ease infinite alternate 0.4s;
}

@keyframes beating {
  from {
    transform: translateY(0px) scale(0.8);
  }

  to {
    transform: translateY(-6px) scale(1.2);
  }
}

.goMediaBtn {
  width: 100%;
  margin: 20px 0 10px;
  padding: 0 15px;
  border-radius: 20px;
}
.mediaDiv {
  margin-top: 10px;
  padding-top: 10px;
  box-shadow: darkgray 0 -7px 8px -1px;
}
.mediaDiv div {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-around;
}
.mediaDiv img {
  height: 60px;
  width: 40px;
}
.cancleShowMedia img {
  height: 25px;
  width: auto;
}

.other-box {
  .other-quesiton {
    margin-top: 20px;
    .other-title {
      // color: #333;
    }
    .other-content {
      color: #145dff;
      cursor: pointer;
    }
  }
}
.no-data {
  text-align: center;
}
.stop-request {
  position: fixed;
  bottom: 85px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  left: 50%;
  transform: translatex(-50%);
  border: 1px solid #145dff;
  border-radius: 6px;
  cursor: pointer;
  background: #fff;
  z-index: 9999;
  .stop-icon {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    background: #145dff;
    margin-right: 10px;
  }
}
.page-info {
  padding: 20px;
  font-size: 18px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.start-box {
  .start-title {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 20px;
  }
  .start-list {
    display: flex;
    // align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    .start-item {
      display: flex;
      align-items: center;
      width: 49%;
      background: #f6f8fc;
      padding: 10px;
      border-radius: 6px;
      box-sizing: border-box;
      cursor: pointer;
      .start-item-title {
        font-size: 16px;
        // font-weight: 700;
        margin-bottom: 10px;
      }
      img {
        margin-right: 10px;
        width: 26px;
        filter: drop-shadow(4px 4px 2px #409eff);
      }
      .start-item-content {
        color: #666;
      }
    }
    .start-item:nth-child(1),
    .start-item:nth-child(2) {
      margin-bottom: 10px;
    }
  }
}

.start-box1 {
  text-align: center;
}
.chat-ass {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 22px;
  font-size: 14px;
  color: #333;
  & > div:first-child {
    flex-shrink: 0;
    margin-right: 10px;
  }
  // .ass-list {
  //   display: flex;
  //   flex: 1;
  //   overflow: hidden;

  .ass-item {
    padding: 6px 10px;
    background: #fff;
    margin-right: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // width: 20%;
    // min-width: 100px;
    max-width: 200px;
    border-radius: 6px;
    cursor: pointer;
    margin: 8px 4px 0 0;
  }
  @media screen and (max-width: 900px) {
    .ass-item {
      max-width: 100px;
    }
  }

  // }
  .change-ass {
    flex-shrink: 0;
    color: #1b4aef;
    cursor: pointer;
    margin-top: 8px;
  }
}
</style>
<style lang="scss">
.chat-message .send-content .el-select {
  width: 78px;
}
.chat-message .send-content .el-select .el-input__inner {
  border: none;
  padding: 0;
  font-size: 12px;
}
.table-loading .el-loading-spinner {
  top: 15%;
}
.ai-table td {
  padding-right: 20px;
}
.video-dialog {
  min-width: 340px;
  width: 95%;
}
.video-dialog .video-js {
  max-width: 100%;
}

.el-popover {
  min-width: 0;
}
.select-box .el-popover__reference-wrapper {
  display: flex;
  align-items: center;
}
.select-list ul li {
  line-height: 28px;
  a {
    color: #333;
    text-decoration: underline;
  }
  text-align: center;
}

.questionnaire {
  .naire-title {
    margin-bottom: 30px;
  }
  .el-form-item {
    margin-bottom: 8px;
    .el-form-item__label {
      text-align: left;
    }
    .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
    .el-radio {
      margin-bottom: 8px;
      margin-right: 0;
      .el-radio__label {
        white-space: pre-wrap;
        margin-right: 20px;
      }
    }
  }
}
.el-scrollbar .el-scrollbar__bar {
  opacity: 1 !important;
}
.feedback-list {
  .el-checkbox-button {
    .el-checkbox-button__inner {
      border: none;
      margin: 0 10px 10px 0 !important;
      border-radius: 6px;
      border-left: none !important;
      background: #ddd;
      color: #333;
      box-shadow: none;
    }
  }
  .is-checked {
    .el-checkbox-button__inner {
      background: #589ef8;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/official/chatassistant.vue